module.exports = __webpack_public_path__ + "static/media/comingsoon-legend.899682e1.jpg";